import { render, staticRenderFns } from "./ManageSeries.vue?vue&type=template&id=58f15481&"
import script from "./ManageSeries.vue?vue&type=script&lang=js&"
export * from "./ManageSeries.vue?vue&type=script&lang=js&"
import style0 from "./ManageSeries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports